'use client';

import { useEffect } from 'react';

import { authClient } from '@/lib/auth/client';
import { useLoginPopup } from '@/lib/ui/useLoginPopup';
import { useTranslations } from '@/i18n/useTranslations';

import PopupShell from './PopupShell';
import Spinner from '@/ui/components/Spinner';

import button from '@/styles/button.module.sass';
import divs from '@/styles/divs.module.sass';
import text from '@/styles/text.module.sass';
import styles from './index.module.sass';

export default function LoginPopup() {
  const { t } = useTranslations('Popup');
  const open = useLoginPopup((s) => s.open);
  const hide = useLoginPopup((s) => s.hide);
  const retry = useLoginPopup((s) => s.payload?.retry);

  useEffect(() => {
    if (!open || !retry) return;
    const interval = window.setInterval(retry, 3000);
    return () => window.clearInterval(interval);
  }, [open, retry]);

  return (
    <PopupShell open={open} onClose={hide}>
      <div className={divs.flexCl8}>
        <h2 className={text.h2}>{t('header')}</h2>
        <div className={divs.flex8}>
          <p className={text.p}>{t('subheader')}</p>
          <Spinner />
        </div>
      </div>
      <hr className={styles.divider} />
      <p className={text.p}>{t('description')}</p>
      <div className={`${button.hWrapper} ${styles.actions}`}>
        <button className={button.secondary} onClick={hide}>
          {t('close')}
        </button>
        <button
          className={button.accent}
          onClick={() => {
            void authClient.signIn.oauth2({ providerId: 'telegram' });
          }}
        >
          {t('login_with_telegram')}
        </button>
      </div>
    </PopupShell>
  );
}
